module.exports = __webpack_public_path__ + "8ff9e33618cddd795ebe1e5e44389de5.png";